export default __webpack_public_path__ + "static/media/nagehan1.921c86fb.jpg";